"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomImage = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importStar(require("react"));
const CustomImage = (props) => {
    const { src, alt, srcPlaceholder, srcErrorImage } = props;
    const [onErrorImage, setOnErrorImage] = (0, react_1.useState)(false);
    const [imgSrc, setImgSrc] = (0, react_1.useState)(src);
    const [loaded, setLoaded] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (onErrorImage && imgSrc !== srcErrorImage && imgSrc !== srcPlaceholder) {
            setImgSrc(srcErrorImage ? srcErrorImage : srcPlaceholder);
        }
    }, [onErrorImage]);
    (0, react_1.useEffect)(() => {
        if (src !== imgSrc) {
            setImgSrc(src);
            setLoaded(false);
            setOnErrorImage(false);
        }
    }, [src]);
    return onErrorImage ? (react_1.default.createElement(components_core_1.Image, { alt: alt, src: imgSrc })) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_core_1.Image, { alt: alt, src: srcPlaceholder, style: loaded ? { display: 'none' } : {} }),
        typeof window !== 'undefined' && typeof document !== 'undefined' && (react_1.default.createElement(components_core_1.Image, { alt: alt, src: imgSrc, onError: () => setOnErrorImage(true), onLoad: () => setLoaded(true), style: loaded ? {} : { display: 'none' } }))));
};
exports.CustomImage = CustomImage;
